export const SPECIAL_LOCATION_COMPANY_ID = 1880420;

export type PersonCardTextLineInput = {
  companyId?: number | null;
  location?: string | null;
  companyName?: string | null;
  personDesignation?: string | null;
  headline?: string | null;
};

export type PersonCardTextLines = {
  primaryLine: string;
  headlineLine: string;
  companyLine: string;
};

export type PersonListRowText = {
  roleLine: string;
  companyLine: string;
};

const normalizeText = (value?: string | null) => (value ?? '').trim();

export const getPersonCardTextLines = ({
  companyId = 0,
  location,
  companyName,
  personDesignation,
  headline,
}: PersonCardTextLineInput): PersonCardTextLines => {
  const designation = normalizeText(personDesignation);
  const headlineText = normalizeText(headline);
  const company = normalizeText(companyName);
  const personLocation = normalizeText(location);

  if (companyId === SPECIAL_LOCATION_COMPANY_ID) {
    return {
      primaryLine: personLocation || company,
      headlineLine: '',
      companyLine: '',
    };
  }

  const headlineLine = headlineText && headlineText !== designation
    ? headlineText
    : (!designation ? headlineText : '');

  return {
    primaryLine: designation,
    headlineLine,
    companyLine: company,
  };
};

export const getPersonListRowText = (input: PersonCardTextLineInput): PersonListRowText => {
  const { primaryLine, headlineLine, companyLine } = getPersonCardTextLines(input);

  return {
    roleLine: primaryLine || headlineLine,
    companyLine,
  };
};
